export const SET_CST_COLLECTION = 'CST/SET_CST_COLLECTION';
export const SET_CST_IPI_COLLECTION = 'CST/SET_CST_IPI_COLLECTION';
export const SET_CST_PIS_COLLECTION = 'CST/SET_CST_PIS_COLLECTION';
export const SET_CST_COFINS_COLLECTION = 'CST/SET_CST_COFINS_COLLECTION';
